import React from 'react';
import './AboutContent.css';
import { PhotoCollage } from './PhotoCollage';
import { ContactSection } from './ContactEmail';

export function AboutContent() {
  return (
    <section className="page-shell about-content">
      <PhotoCollage />
      <div className="about-text-block">
        <h1 className="about-heading">Nice to see you again,</h1>
        <p className="about-text">
          I am a Data Analyst at BNY, working within the Data and Analytics team.
          I build data management and analysis solutions for buy-side clients.
        </p>
        <p className="about-text">
          My work spans data management, analysis, and visualization. I work with SQL, Python, and
          Power BI to automate manual processes, surface new insights, and deliver better front
          office experiences.
        </p>
        <p className="about-text">
          Previously, I worked at Century Tech as part of the Science Content Team, developing the
          science curriculum and creating interactive learning content.
        </p>
        <p className="about-text">
          I also spent time at the startup Agora as a Software Developer, focusing on front-end
          experiences built with React, Flask, and Python. Teaching has been a passion too, so I
          spent time tutoring A-level physics students.
        </p>
        <p className="about-text">
          Outside of work, I love finding new food experiences, building things with my hands, and
          creating projects that turn ideas into tangible results.
        </p>
        <p className="about-text">
          If you feel like a chat, please do not hesitate to <ContactSection />.
        </p>
      </div>
    </section>
  );
}
